import { Modal } from "antd";
import React from "react";

interface DeleteUserModalProps {
  visible: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const DeleteUserModalProps: React.FC<DeleteUserModalProps> = ({ visible, onCancel, onConfirm }) => {
  return (
    <Modal title="Confirm Delete" visible={visible} onOk={onConfirm} onCancel={onCancel}>
      <p>Are you sure you want to delete this user?</p>
    </Modal>
  );
};

export default DeleteUserModalProps;
